import React from 'react'
import { connect } from 'react-redux'

import DefaultReceiptDetails from './DefaultReceiptDetails'
import SuitesReceiptDetails from './SuitesReceiptDetails'

import { getIsSuitesOrTabsMode } from '../../selectors/config'

const ReceiptDetails = ({ isSuitesOrTabs }) => {
  if (isSuitesOrTabs) {
    return <SuitesReceiptDetails />
  } else {
    return <DefaultReceiptDetails />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isSuitesOrTabs: getIsSuitesOrTabsMode(state)
  }
}

export default connect(mapStateToProps, undefined)(ReceiptDetails)
